
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageGeneral]",
      function () {
        return require("private-next-pages/[pageGeneral].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageGeneral]"])
      });
    }
  